import bindAll from 'lodash.bindall';
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import wx from 'weixin-js-sdk'

import {
    getIsFetchingWithoutId,
    setProjectId,

    /* 打开作品@米德 */
    setWorkInfo,
    setWorkIsShare,
    setWorkUuid,
    setWorkType,
    setKeyboard,
    onFetchedProjectData,
    setWorkDescription,
} from '../reducers/project-state';
import {setProjectTitle} from '../reducers/project-title';
import {openLoadingProject, closeLoadingProject} from '../reducers/modals';
import mideApi from '../lib/mide-api';
import config from "./mide-api/config";

/* Higher Order Component to get the project id from location.hash
 * @param {React.Component} WrappedComponent: component to render
 * @returns {React.Component} component with hash parsing behavior
 */
const HashParserHOC = function (WrappedComponent) {
    class HashParserComponent extends React.Component {
        constructor(props) {
            super(props);
            bindAll(this, [
                'handleHashChange'
            ]);

            this.state = {
                loading: true
            };
        }

        componentDidMount() {
            window.addEventListener('hashchange', this.handleHashChange);
            this.handleHashChange();
        }

        componentDidUpdate(prevProps) {
            // if we are newly fetching a non-hash project...
            if (this.props.isFetchingWithoutId && !prevProps.isFetchingWithoutId) {
                // ...clear the hash from the url
                history.pushState('new-project', 'new-project',
                    window.location.pathname + window.location.search);
            }
        }

        componentWillUnmount() {
            window.removeEventListener('hashchange', this.handleHashChange);
        }

        handleHashChange() {
            this.props.openLoadingProject();
            if (window.location.search.length > 0) {
                let workType = null;
                const query = window.location.search.split('?')[1].split('&');
                // console.log(query, '00000');
                query.forEach(i => {
                    const key = i.split('=')[0];
                    const value = i.split('=')[1];
                    // const uuid = i.split('=')[3];
                    // console.log(i, key, value, '000000000');
                    if (key === 'isShare') {
                        this.props.setWorkIsShare(1);
                    }
                    if (key === 'workType') {
                        workType = parseInt(value, 0);
                        this.props.setWorkType(parseInt(value, 0));
                    }
                    if (key === 'workUuid' && value.length === 32) {
                        this.props.setWorkUuid(value);
                        mideApi.work.detail(value)
                            .then(res => {
                                if (res.data.code !== 1 && window.location.search.indexOf('isMobile') === -1) {
                                    location.href = '/login.html';
                                }
                                // if ((res.data.data.userType === 4 && (res.data.data.type === 1 || res.data.data.type === 3 || res.data.data.type === 4 || res.data.data.type === 6)) || location.search.indexOf('courseware') !== -1 || location.search.indexOf('isMobile') === -1) {
                                //     document.title = res.data.data.name + ' - 米德教育 - 现在学编程，从小就做实力派！';
                                // }

                                document.title = res.data.data.name + ' - 米德教育 - 现在学编程，从小就做实力派！';

                                if (location.search.indexOf('isMobile') !== -1 && res.data.data.userType === 4 && (res.data.data.type === 1 || res.data.data.type === 3 || res.data.data.type === 4)) {
                                    const name = res.data.data.userName;
                                    // let name = res.data.data.userName;
                                    // if (res.data.data.userName && res.data.data.userName.length > 1) {
                                    //     if (res.data.data.userName.length <= 3) {
                                    //         name = res.data.data.userName.slice(1);
                                    //     } else {
                                    //         name = res.data.data.userName.slice(2);
                                    //     }
                                    // }
                                    const url =window.location.href;

                                    mideApi.getWXSign().then(() => {
                                        // 分享给朋友或分享到QQ
                                        wx.updateAppMessageShareData({
                                            title: `${name}《${res.data.data.name}》`,
                                            desc: '现在学编程，从小就做实力派！阿基米德中国青少儿编程教育先行者。',
                                            link: url,
                                            imgUrl: mideApi.config.scratchAssetRoot + res.data.data.coverUrl,
                                            success() {
                                                console.log('分享成功');
                                            }
                                        });

                                        // 分享到朋友圈或QQ空间
                                        wx.updateTimelineShareData({
                                            title: document.title,
                                            link: url,
                                            imgUrl: mideApi.config.scratchAssetRoot + res.data.data.coverUrl,
                                            success() {
                                                console.log('分享成功');
                                            }
                                        });
                                    })
                                } else if (location.search.indexOf('isMobile') !== -1 && !(res.data.data.userType === 4 && (res.data.data.type === 1 || res.data.data.type === 3 || res.data.data.type === 4))) {
                                    mideApi.wxMenuHide.wxMenuHide();
                                }
                                const projectId = res.data.data.url;
                                this.props.setWorkInfo(res.data.data);
                                this.props.setProjectId(projectId);
                                return mideApi.work.jsonData(projectId);
                            })
                            .then(res => {
                                const workJson = res.data.code ? res.data.data : JSON.stringify(res.data);
                                const keyList = [];
                                this.props.onFetchedProjectData(workJson, 'FETCHING_WITH_ID');
                                this.setState({loading: false});

                                JSON.parse(workJson).targets.forEach(i => {
                                    for (let key in i.blocks) {
                                        if (i.blocks[key].opcode === "event_whenkeypressed" || i.blocks[key].opcode === "sensing_keyoptions") {
                                            const keyPressed = i.blocks[key].fields.KEY_OPTION[0];
                                            keyList.push(keyPressed);
                                        }
                                    }
                                });
                                this.props.setKeyboard(Array.from(new Set(keyList)));
                                this.props.closeLoadingProject();
                            });
                    }
                });
                // /* 课标作品，课程介绍*/
                // const classUuidIndex = query.findIndex((i) => i.indexOf('classUuid') !== -1);
                // const scheduleUuidIndex = query.findIndex((i) => i.indexOf('scheduleUuid') !== -1);
                // if (classUuidIndex !== -1 && scheduleUuidIndex !== -1) {
                //     const classUuid = query[classUuidIndex].split('=')[1];
                //     const classScheduleUuid = query[scheduleUuidIndex].split('=')[1];
                //     mideApi.work.snapshot(classUuid, classScheduleUuid).then((value) => {
                //         this.props.setWorkDescription(value.data.data);
                //     })
                // } else {
                //     const data = {
                //         workOperation: null,
                //         workDescription: null,
                //     };
                //     this.props.setWorkDescription(data);
                // }

            }
        }

        render() {
            const {
                closeLoadingProject,
                openLoadingProject,
                /* eslint-disable no-unused-vars */
                isFetchingWithoutId: isFetchingWithoutIdProp,
                reduxProjectId,
                setProjectId: setProjectIdProp,
                /* eslint-disable no-shadow */
                workType,
                workUuid,
                setProjectTitle,
                setWorkInfo,
                setWorkUuid,
                setWorkType,
                setKeyboard,
                /* eslint-disable no-shadow */
                /* eslint-enable no-unused-vars */
                ...componentProps
            } = this.props;
            return !this.state.loading ? (
                <WrappedComponent
                    {...componentProps}
                />
            ) : null;
        }
    }

    HashParserComponent.propTypes = {
        isFetchingWithoutId: PropTypes.bool,
        reduxProjectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        setProjectId: PropTypes.func,
        /* 打开作品@米德 */
        workType: PropTypes.number,
        workUuid: PropTypes.string,
        setProjectTitle: PropTypes.func,
        setWorkInfo: PropTypes.func,
        setWorkIsShare: PropTypes.func,
        setWorkUuid: PropTypes.func,
        setWorkType: PropTypes.func,
        setKeyboard: PropTypes.func,
        onFetchedProjectData: PropTypes.func,
        openLoadingProject: PropTypes.func,
        closeLoadingProject: PropTypes.func,
        /**/
        setWorkDescription: PropTypes.func,
        workDescription: PropTypes.object,
    };
    const mapStateToProps = state => {
        const loadingState = state.scratchGui.projectState.loadingState;
        return {
            isFetchingWithoutId: getIsFetchingWithoutId(loadingState),
            reduxProjectId: state.scratchGui.projectState.projectId,
            workType: state.scratchGui.projectState.workType,
            workUuid: state.scratchGui.projectState.workUuid,
            workDescription: state.scratchGui.projectState.workDescription, // 作品简介
        };
    };
    const mapDispatchToProps = dispatch => ({
        openLoadingProject: () => dispatch(openLoadingProject()),
        closeLoadingProject: () => dispatch(closeLoadingProject()),
        setProjectId: projectId => dispatch(setProjectId(projectId)),
        /* 打开作品@米德 */
        setProjectTitle: workTitle => dispatch(setProjectTitle(workTitle)),
        setWorkInfo: workInfo => dispatch(setWorkInfo(workInfo)),
        setWorkIsShare: workIsShare => dispatch(setWorkIsShare(workIsShare)),
        setWorkUuid: workUuid => dispatch(setWorkUuid(workUuid)),
        setWorkType: quizUuid => dispatch(setWorkType(quizUuid)),
        setKeyboard: keyboard => dispatch(setKeyboard(keyboard)),
        onFetchedProjectData: (data, state) => dispatch(onFetchedProjectData(data, state)),
        /**/
        setWorkDescription: workDescription => dispatch(setWorkDescription(workDescription)),
    });
    // Allow incoming props to override redux-provided props. Used to mock in tests.
    const mergeProps = (stateProps, dispatchProps, ownProps) => Object.assign(
        {}, stateProps, dispatchProps, ownProps
    );
    return connect(
        mapStateToProps,
        mapDispatchToProps,
        mergeProps
    )(HashParserComponent);
};

export {
    HashParserHOC as default
};
